import React from "react";

function EyeHideLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M8.28498 15.6883L6.67581 15.2566L7.33165 12.8074C6.34995 12.4454 5.43758 11.9177 4.63415 11.2474L2.83998 13.0424L1.66081 11.8633L3.45581 10.0691C2.44254 8.85555 1.76172 7.39972 1.47998 5.84409L3.11998 5.54492C3.75248 9.04659 6.81581 11.7033 10.5 11.7033C14.1833 11.7033 17.2475 9.04659 17.88 5.54492L19.52 5.84326C19.2386 7.3991 18.5581 8.85523 17.545 10.0691L19.3391 11.8633L18.16 13.0424L16.3658 11.2474C15.5624 11.9177 14.65 12.4454 13.6683 12.8074L14.3241 15.2574L12.715 15.6883L12.0583 13.2383C11.0269 13.415 9.97302 13.415 8.94165 13.2383L8.28498 15.6883Z"
        fill="#0E0E0E"
      />
    </svg>
  );
}

export default EyeHideLogo;
